<template>
  <th v-if="isHeader">
    {{'Actions' | translate}}
  </th>
  <td v-else>
    <div class="custom-actions">
    <button class="btn btn-primary mb-1 edit-button" @click="itemAction('edit', rowData, rowIndex)"><i class="icons icon-note"></i>&nbsp;{{ 'Edit' | translate }}</button>
    <button class="btn btn-danger mb-1 delete-button"  v-if="(typeof this.rowField['disableFn'] !== 'undefined' && typeof this.rowField['disableFn'].delete !== 'undefined') !== true" @click="itemAction('delete', rowData, rowIndex)"><i class="icons icon-trash"></i>&nbsp;{{ 'Delete' | translate }}</button>
    <button class="btn btn-success mb-1" v-if="(typeof this.rowField['disableFn'] !== 'undefined' && typeof this.rowField['disableFn'].auditStock !== 'undefined') !== true" @click="itemAction('auditStock', rowData, rowIndex)">
      <span class="icon icon-check"></span>&nbsp;{{ 'Audit Stock' | translate }}
    </button>
  </div>
  </td>
</template>

<script>
import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin'

export default {
  mixins: [VuetableFieldMixin],
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    itemAction (action, data, index) {
      if (action === 'delete') {
        if (confirm(this.$t('Are you sure?'))) {
          this.$router.push({ path: this.$route.path + '/' + action + '/' + data.id })
        }
      } else if (action === 'auditStock') {
        var d = {}
        d['flata_id'] = data.id
        d['initiator'] = 'ADMIN'
        d['reason'] = 'STOCK_AUDIT'
        var vm = this
        this.$http.post('customerlog', {data: d}).then(function (res) {
          if (res.status === 200) {
            vm.$notify({
              group: 'full',
              text: res.data.msg
            })
            this.$parent.refresh()
          } else {
            vm.$notify({
              group: 'full',
              text: res.data.msg
            })
          }
        })
      } else {
        this.$router.push({ path: this.$route.path + '/' + action + '/' + data.id })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// VueTableFlataActions.vue?3b46127c